<!-- Loading spinner -->
<div *ngIf="loading">
  <app-loading [show]="loading"></app-loading>
</div>

<!-- Main menu -->
<!-- <app-menu-bar
  *ngIf="shouldIShowMenu()"
  [navLinks]="getActiveModuleSections()"
></app-menu-bar> -->

<app-menu-bar-tooly
  *ngIf="shouldIShowMenu()"
  [navLinks]="getActiveModuleSections()"
  [activeOmniverseSideBar]="activeOmniverseSideBar"
  [optionsLeftTop]="optionsLeftTop"
  [optionsLeftDown]="optionsLeftDown"
></app-menu-bar-tooly>

<!-- Lazy load app margin left for sidebar menu-->
<div
  class="relative lg:border-rounded-200"
  [ngClass]="{
    'lg:pl-[74px] lg:pr-6  ': this.authService.isLoggedIn(),
    'pt-[72px]': shouldIShowMenu()
  }"
>
  @if (this.authService.isLoggedIn()) {
    <!-- simulating border right -->
    <div
      class="hidden lg:block w-[24px] h-screen fixed right-0 top-0 bg-azure-400 z-40"
    ></div>
  }

  <!-- content -->
  <router-outlet></router-outlet>
</div>

<!-- extra info -->
<!-- Beta version text -->
<p
  *ngIf="shouldShowClosedBeta()"
  class="fixed bottom-4 right-3 lg:right-12 text-body-s z-30 text-neutral-175"
>
  Beta version. Not indicative of final product.
</p>

<!-- modals -->
<!-- Lazy load app -->

<app-welcome-modal #welcomeModal />
<app-steam-key-modal />
<app-help-modal />
<app-become-gamesmith-modal />
<app-opening-tool-modal />
<app-report-modal />
<app-play-adventure-modal />
<app-duplicate-item-modal />
<app-upgrade-modal #upgradeModal />
<app-feature-locked-modal #featureLockedModal />
